export class CmsHtmlPage {
  constructor(
    public view: string,
    public styles: string,
    public order: number,
    public newWindow: boolean,
    public loggedOnly: boolean,
    public alias: string,
    public label: string,
    public modal: boolean,
    public componentName,
    public externalUrl: CmsExternalUrl,
    public additionalParameters: Map<string, object>,
    public active: boolean,
    public area: string
  ) {
  }
}

export class CmsExternalUrl {
  constructor(
    public pl: string,
    public en: string
  ) {
  }
}
